import { render, staticRenderFns } from "./IdCardInput.vue?vue&type=template&id=240747c9&scoped=true&"
import script from "./IdCardInput.vue?vue&type=script&lang=js&"
export * from "./IdCardInput.vue?vue&type=script&lang=js&"
import style0 from "./IdCardInput.vue?vue&type=style&index=0&id=240747c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240747c9",
  null
  
)

export default component.exports